// closePopupNotifications.js
'use strict';

import { REMOVE_LIST_ITEMS, REMOVE_OPERATION_DATA } from '../ActionTypes.js';
import removeModals from '../action/removeModals.js';
import Delay from '../resource/Delay.js';
import {
  STATUS_CLOSING,
  NOTIFICATION_CENTER_POPUP_LIST,
  LIST_SELECT_PATH_PREFIX,
  DETAIL_SELECT_PATH_PREFIX,
  MODAL_ID_PREFIX,
} from '../resource/popupNotificationConstants.js';

/**
 * Close notifications
 * @kind action
 * @param {array} [{notificationTags}] - be closed notification tags.
 * @param {boolean} {isNotificationCenter} - is notification come from notification center.
 * User click a item in notification center, this notification will be add into NOTIFICATION_CENTER_POPUP_LIST only.
 * So that user can view notification center item in livestream detail.
 * @return {Promise} Action promise.
 */
const closePopupNotifications =
  ({ notificationTags = [], isNotificationCenter } = {}) =>
  async dispatch => {
    const modalIds = notificationTags.map(tag => `${MODAL_ID_PREFIX}${tag}`);

    dispatch(
      removeModals({
        ids: modalIds,
        transitionStatus: STATUS_CLOSING,
      })
    );

    const delay = new Delay(600);

    await delay.promise();

    dispatch({
      type: REMOVE_LIST_ITEMS,
      payload: {
        selectPath: isNotificationCenter
          ? NOTIFICATION_CENTER_POPUP_LIST
          : LIST_SELECT_PATH_PREFIX,
        itemIds: notificationTags,
      },
    });

    return notificationTags.map(tag =>
      dispatch({
        type: REMOVE_OPERATION_DATA,
        payload: {
          selectPath: [...DETAIL_SELECT_PATH_PREFIX, tag],
        },
      })
    );
  };

export default closePopupNotifications;
